import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full pt-20 pb-32 px-6 md:px-12 lg:px-24 overflow-visible" data-id="element-528">
      {/* Background Image */}
      <div className="absolute top-0 right-0 pointer-events-none" style={{
      width: '100%',
      height: '800px'
    }} data-id="element-529">
        <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[12%] w-[100%] h-auto opacity-90" data-id="element-530" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-531">
        <div className="flex flex-col space-y-8" data-id="element-532">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 mt-20 w-fit" data-id="element-533">
            <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-534">
              THE CONTEXTUAL INTELLIGENCE COMPANY
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight max-w-6xl font-['Syne'] text-black" data-id="element-535">
            <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight max-w-6xl font-['Syne'] text-black" data-id="element-536">
              The <span className="bg-blue-600 text-white px-3" data-id="element-537">Context</span>{' '}
              Engineering Platform for Enterprise AI.
            </h1>
          </h1>

          <div data-id="element-538">
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl font-light" data-id="element-539">
              Synthia creates a shared context library for how an enterprise
              thinks, <br data-id="element-540" />
              helping humans and agents work to the same standards. Before AI
              generates anything,{' '}
              <strong className="font-semibold text-gray-900" data-id="element-541">
                Synthia applies the right context at the right time,
              </strong>{' '}
              so outputs are consistent and trustworthy.
            </p>

            <p className="text-lg md:text-xl text-black leading-relaxed max-w-2xl mt-4" data-id="element-542">
              They own the compute.{' '}
              <strong className="font-bold" data-id="element-543">You own the logic.</strong>
            </p>
          </div>

          <div className="pt-4" data-id="element-544">
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0066FF]" data-id="element-545">
              BOOK A DEMO
              <ArrowRight className="w-5 h-5" data-id="element-546" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}